<template>
  <TSliderRange
    v-model:range="range"
    :min="min"
    :max="max"
    :step="step"
    :min-label="formatLabel(range[0])"
    :max-label="formatLabel(range[1])"
  />
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  rangeObject: { min?: number, max?: number }
  min?: number
  max?: number
  step?: number
  labelFormatter?: string
  hideLabels?: boolean
  plusOnMaxValue?: boolean
}>(), {
  min: 1,
  max: 100,
  step: 1,
  labelFormatter: '{value}',
})

const emit = defineEmits<{
  update: [{ min?: number, max?: number }]
}>()

function formatLabel(value: number) {
  const text = props.labelFormatter.replace(/\{value\}/g, value.toString())
  return props.plusOnMaxValue && value >= props.max ? `${text}+` : text
}

const range = ref<[number, number]>([props.rangeObject.min ?? props.min, props.rangeObject.max ?? props.max])
watch(props.rangeObject, (newValue) => {
  range.value = [newValue.min ?? props.min, newValue.max ?? props.max]
})

watch(range, (newValue) => {
  const min = newValue[0] <= props.min ? undefined : newValue[0]
  const max = newValue[1] >= props.max ? undefined : newValue[1]

  emit('update', { min, max })
})
</script>
